import { CheckPersonRulesMatrixModel, CourtForAddBookingModel, PersonModel } from '@bayclubs/court-booking-employee-api';
import { BcStateListContext, BcStateForm } from '@bayclubs/state';

import { CourtBookingSaveFormModel, CourtBookingSaveTimeSlotModel } from './../models/court-booking-save-form.model';

export const COURT_BOOKING_SAVE_FEATURE_KEY = 'cbCourtBookingSave';

export interface CourtBookingSaveStateModel {
    players: BcStateListContext<PersonModel>;
    courtBookingForm: BcStateForm<CourtBookingSaveFormModel>;
    courts: BcStateListContext<CourtForAddBookingModel>;
    timeSlots: BcStateListContext<CourtBookingSaveTimeSlotModel>;
    playerRules: BcStateListContext<CheckPersonRulesMatrixModel>;
}
